/* eslint-disable key-spacing */

const ITEM_LIST = {
  weapon:          { localeKey: 'weapon', isEquipment: true },
  armor:           { localeKey: 'armor', isEquipment: true },
  head:            { localeKey: 'headgear', isEquipment: true },
  shield:          { localeKey: 'offhand', isEquipment: true },
  back:            { localeKey: 'back', isEquipment: true },
  body:            { localeKey: 'body', isEquipment: true },
  headAccessory:   { localeKey: 'headAccessory', isEquipment: true },
  eyewear:         { localeKey: 'eyewear', isEquipment: true },
  hatchingPotions: { localeKey: 'hatchingPotion', isEquipment: false },
  premiumHatchingPotions: { localeKey: 'hatchingPotion', isEquipment: false },
  eggs:            { localeKey: 'eggSingular', isEquipment: false },
  quests:          { localeKey: 'quest', isEquipment: false },
  food:            { localeKey: 'foodTextThe', isEquipment: false },
  Saddle:          { localeKey: 'foodSaddleText', isEquipment: false },
  bundles:         { localeKey: 'discountBundle', isEquipment: false },
};

export default ITEM_LIST;
